import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect(){
    this.hiddenClass = this.element.dataset.hiddenClass || 'hidden';
  }

  show(event){
    this.execute(this.targetsByEvent(event), 'show')
  }

  hide(event){
    this.execute(this.targetsByEvent(event), 'hide')
  }

  targetValue(event){
    return event.currentTarget.dataset.toggleValue || 'true';
  }

  toggleInverse(event){
    return !!event.currentTarget.dataset.toggleInverse;
  }

  targetsByEvent(event){
    let names = event.currentTarget.dataset.toggleTarget.split(",");
    let targets = []
    names.forEach((target) =>
      targets.push(document.querySelector(`[data-toggle-name="${target}"]`))
    )
    return targets;
  }

  toggleByValue(event) {
      console.log(this.toggleInverse(event))
    if(!this.toggleInverse(event)) {
      if(event.currentTarget.value === this.targetValue(event)){
        this.show(event);
      } else {
        this.hide(event);
      }
    } else {
      if(event.currentTarget.value !== this.targetValue(event)){
        this.show(event);
      } else {
        this.hide(event);
      }
    }
  }

  toggleByChecked(event) {
    if(event.currentTarget.checked){
      this.show(event);
    } else {
      this.hide(event);
    }
  }

  toggleText(event) {
    let targets = this.targetsByEvent(event);
    let eventTarget = event.currentTarget;
    targets.forEach((target) => {
      if(target.classList.contains(this.hiddenClass)) {
        if(eventTarget.dataset.toggleTextHidden)
          eventTarget.innerHTML = eventTarget.dataset.toggleTextHidden;
      } else {
        if(eventTarget.dataset.toggleTextShown)
          eventTarget.innerHTML = eventTarget.dataset.toggleTextShown;
      }
    })
  }

  toggleByClick(event) {
    event.preventDefault();
    this.toggle(event);
    this.toggleText(event);
  }

  toggle(event) {
    this.execute(this.targetsByEvent(event))
  }

  execute(targets, action){
    targets.forEach((target) => {
      if(action == 'show'){
        target.classList.remove(this.hiddenClass)
      } else if (action == 'hide'){
        target.classList.add(this.hiddenClass)
      } else {
        target.classList.toggle(this.hiddenClass)
      }
      target.querySelectorAll('input, select, textarea').forEach((input) => {
        input.disabled = target.classList.contains(this.hiddenClass)
      });
    });
  }
}
